import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AnalyticsSpeed from "@/pages/AnalyticsSpeed";
import SourcesAnalytics from "@/pages/SourcesAnalytics";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Courses from "@/pages/Courses";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import AiSearch from "@/pages/AiSearch";
import Campaigns from "@/pages/Campaigns";
import QualityLabels from "@/pages/QualityLabels";
import WonLeads from "@/pages/WonLeads";
import AutoForwardPreview from "@/pages/AutoForwardPreview";
import HandlingReport from "@/pages/HandlingReport";
import Pagelle from "@/pages/Pagelle";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/analytics/speed" element={<AnalyticsSpeed />} />
        <Route path="/campagne" element={<Campaigns />} />
        <Route path="/qualita" element={<QualityLabels />} />
        <Route path="/vinti" element={<WonLeads />} />
        <Route path="/report-gestione" element={<HandlingReport />} />
        <Route path="/pagelle" element={<Pagelle />} />
        <Route path="/analytics/sources" element={<SourcesAnalytics />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/inoltri" element={<Leads mode="forwards" />} />
        <Route path="/inoltri-auto" element={<AutoForwardPreview />} />
        <Route path="/leads/:id" element={<LeadDetail />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/ricerca-ia" element={<AiSearch />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
